import {
  AnyAssetApplication,
  AnyAssetSubType,
  assetSubTypeToPermission,
  PageContent,
  PermissionGuard,
  useAssetConfig,
  useAssetTranslation,
} from '@mss/mss-component-library';
import AssetType from './AssetType';
import React from 'react';

export default function SelectNewAsset<
  AssetType extends AnyAssetApplication,
>() {
  const { t } = useAssetTranslation();
  const {
    config: { name, permissions, assets },
  } = useAssetConfig<AssetType>();

  return (
    <PageContent
      title={t('Choose ((assetType)) type', { assetType: name })}
    >
      <PermissionGuard codename={permissions.map(p => `add_${p}`)} any redirect>
        <ul className="list-none p-0 m-0">
          {Object.keys(assets).map(assetName => {
            // @ts-ignore
            const asset = assets[assetName as AnyAssetSubType];
            if (!asset) return null;
            return (
              <PermissionGuard
                codename={`add_${permissions.find(p =>
                  p.includes(assetSubTypeToPermission(asset.type))
                )}`}
                key={asset.type}
              >
                <AssetType
                  title={t(asset.name)}
                  subtitle={t(asset.description)}
                  page={asset.typeURI ?? asset.type}
                  icon={asset.icon}
                  mssIcon={asset.mssIcon}
                />
              </PermissionGuard>
            );
          })}
        </ul>
      </PermissionGuard>
    </PageContent>
  );
}
